module.exports = __webpack_public_path__ + "static/fonts/trebuchet_ms.bd6a3b4.ttf";